const makeName = e => `${e.firstname} ${e.lastname.replace(/ \d{8,}$/, '')}`;

export default makeName;
